module.exports = __webpack_public_path__ + "assets/img/图标／68px@2x(1).aa3e8466.png";